import { useState, useEffect } from 'react';
import axios from 'axios';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Icon from '@mui/material/Icon';
import Typography from '@mui/material/Typography';
import getTheme from '../theme/theme';
import { ThemeProvider } from '@emotion/react';
import { BASEURL } from "../constants/Common"

interface FeaturesProps {
  title: string;
  description: string;
  icon: string;
}

const Features = (): JSX.Element => {
  const theme = getTheme();

  const [features, setFeatures] = useState<FeaturesProps[]>([]);

  const fetchFeatures = () => {
    const url = BASEURL + '/services/';
    axios
      .get<FeaturesProps[]>(url, {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        setFeatures(response.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchFeatures();
  }, []);

  return (
      <ThemeProvider theme={getTheme()}>
    <div id='features'>
      <Box
        sx={{
          pt: 5,
          pb: 10,
          px: 2,
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Box marginBottom={4}>
          <Typography
            variant='h5'
            align='center'
            fontWeight={700}
            marginTop={theme.spacing(1)}
            gutterBottom
            sx={{
              color: theme.palette.text.primary,
              textTransform: 'uppercase',
            }}
          >
            Features
          </Typography>
          <Typography
            variant='subtitle1'
            align='center'
            marginTop={theme.spacing(1)}
            gutterBottom
            color={theme.palette.text.primary}
          >
            We offer a range of features to support your business
          </Typography>
        </Box>
        <Container>
          <Grid container spacing={4}>
            {features.map((item, i) => (
              <Grid item xs={12} sm={6} md={4} key={i}>
                <Box component={Card} padding={4} width={1} height={1}>
                  <Box display='flex' flexDirection='column'>
                    <Box
                      component={Avatar}
                      width={50}
                      height={50}
                      marginBottom={2}
                      bgcolor={theme.palette.primary.main}
                      color={'black'}
                    >
                      <Icon className='material-icons-outlined'>
                        {item.icon}
                      </Icon>
                    </Box>
                    <Typography
                      variant='h6'
                      gutterBottom
                      sx={{ fontWeight: 500 }}
                    >
                      {item.title}
                    </Typography>
                    <Typography color={theme.palette.text.primary}>
                      {item.description}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </div>
  </ThemeProvider>
  );
};

export default Features;
